import React, { useContext, useEffect, useState } from 'react';
import { PagamentosContainer } from './styles';
import { useTheme } from '../../../../contexts/Theme/ThemeContext';
import { Button } from '../../../Button';
import { blingApi, PagamentoBling } from '../../../../hooks/blingApi';
import Swal from 'sweetalert2';
import LoadingComFundo from '../../../Loading/LoadingComFundo/LoadingComFundo';
import { ConfiguracoesContext } from '../../../../contexts/Configuracoes/ConfiguracoesContext';
import { Select } from '../../../Select';

interface PagamentosProps {
    onClose: () => void;
}

type TipoPagamento = 'a_combinar' | 'pix' | 'cartao';

interface MeioPagamento {
    tipo: TipoPagamento;
    label: string;
}

const Pagamentos: React.FC<PagamentosProps> = ({ onClose }) => {
    const api = blingApi();
    const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);
    const { theme } = useTheme();

    const [loading, setLoading] = useState(true);
    const [pagamentosBling, setPagamentosBling] = useState<PagamentoBling[]>([]);
    const [mapeamentoAux] = useState(
        configuracoes.dados_bling_v2?.mapeamento_pagamentos || {}
    );

    const getMeiosPagamentoAtivos = (): MeioPagamento[] => {
        const meios: MeioPagamento[] = [];
        const intermediadores = configuracoes.intermediadores;

        if (intermediadores?.a_combinar?.ativo) {
            meios.push({ tipo: 'a_combinar', label: 'A combinar' });
        }

        let temPix = false;
        let temCartao = false;

        for (const key in intermediadores) {
            if (key === 'a_combinar') continue;

            const gateway = intermediadores[key as keyof typeof intermediadores] as any;
            if (gateway) {
                if (gateway.pix?.ativo && !temPix) {
                    meios.push({ tipo: 'pix', label: 'PIX' });
                    temPix = true;
                }
                if (gateway.cartao?.ativo && !temCartao) {
                    meios.push({ tipo: 'cartao', label: 'Cartão de Crédito' });
                    temCartao = true;
                }
            }
        }

        return meios;
    };

    const buscarPagamentos = async () => {
        try {
            const response = await api.buscarPagamentos();
            setPagamentosBling(response);
        } catch (error) {
            Swal.fire({
                title: 'Erro',
                text: 'Ocorreu um erro ao buscar as formas de pagamento. Tente novamente.',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
            onCancelar();
        }
    };

    const onCancelar = () => {
        setConfiguracoes({
            ...configuracoes,
            dados_bling_v2: {
                ...configuracoes.dados_bling_v2!,
                mapeamento_pagamentos: mapeamentoAux
            }
        });
        onClose();
    };

    const handleChangeMapeamento = (tipo: TipoPagamento, value: string) => {
        const novoMapeamento = {
            ...configuracoes.dados_bling_v2?.mapeamento_pagamentos,
        };

        if (value === '') {
            delete novoMapeamento[tipo];
        } else {
            novoMapeamento[tipo] = Number(value);
        }

        setConfiguracoes({
            ...configuracoes,
            dados_bling_v2: {
                ...configuracoes.dados_bling_v2!,
                mapeamento_pagamentos: novoMapeamento
            }
        });
    };

    useEffect(() => {
        const init = async () => {
            await buscarPagamentos();
            setLoading(false);
        };
        init();
    }, []);

    const meiosAtivos = getMeiosPagamentoAtivos();

    const optionsPagamento = [
        { name: 'Não mapear', value: '' },
        ...pagamentosBling.map(p => ({
            name: p.descricao,
            value: p.id.toString()
        }))
    ];

    return (
        <PagamentosContainer theme={theme} loading={loading}>
            {loading ? (
                <LoadingComFundo />
            ) : (
                <>
                    <div className="titulo">
                        Mapear pagamentos
                    </div>
                    <div className="texto">
                        Vincule os meios de pagamento do Conecta Venda às formas de pagamento cadastradas no Bling.
                    </div>
                    {meiosAtivos.length === 0 ? (
                        <div className="aviso">
                            Nenhum meio de pagamento está ativo nas configurações de intermediadores.
                        </div>
                    ) : (
                        <div className="pagamentos">
                            {meiosAtivos.map((meio) => (
                                <div key={meio.tipo} className="pagamento">
                                    <Select
                                        label={meio.label}
                                        placeholder="Selecione uma forma de pagamento"
                                        options={optionsPagamento}
                                        value={
                                            configuracoes.dados_bling_v2?.mapeamento_pagamentos?.[meio.tipo]?.toString() || ''
                                        }
                                        onChange={(value) => handleChangeMapeamento(meio.tipo, value)}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                    <div className="botoes">
                        <div className="cancelar" onClick={onCancelar}>
                            Cancelar
                        </div>
                        <Button
                            title="Salvar"
                            onClick={onClose}
                        />
                    </div>
                </>
            )}
        </PagamentosContainer>
    );
};

export default Pagamentos;
